/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

export const allRoles: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

export const loginRoles: RoleList = [Roles.LOGIN, ...allRoles];

export const modelMastersAdmin: RoleList = [
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

export const assetRequestAdmins: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.ACCOUNT_MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.MANAGER,
];

export const rushAssetRequestAdmins: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.ACCOUNT_MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.MANAGER,
];

export const userManagement: RoleList = [Roles.SYSTEM_ADMIN, Roles.SYSTEM_ADMIN_REGIONAL];

export const companyCodeInSelectedUserProfile: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

export const downloadCsv: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
  Roles.PURCHASER,
];

export const administrators: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

export const isAdmin = () => {
  const user = localStorage.getItem('user');
  if (!user) return false;
  const activeUser: Object = JSON.parse(user);
  return administrators.indexOf(activeUser.role_id) ? true : false;
};
